import { IExportPromoProductsRepository, IExportPromoProductsRequest } from "@/core/repositories/export/export.promoProducts";
import { PrivateHttp } from "@/infrastructure/adapters/http";
import { ApiEndpoints } from "@/infrastructure/services/config";

export class ExportPromoProductsRepository implements IExportPromoProductsRepository {
  async exportPromoProducts(data: IExportPromoProductsRequest): Promise<{ signedUrl: string; success: boolean }> {
    const response = await new PrivateHttp().post<{ signedUrl: string; success: boolean }>(
      ApiEndpoints.EXPORT_PROMO_PRODUCTS,
      data
    );
    return response;
  }
}
